<template>
    <div></div>
</template>

<script>
    import {SET_BREADCRUMB} from "@/core/services/store/breadcrumbs.module";

    export default {
        name: "SyncDataMonitor",
        mounted() {
            this.$store.dispatch(SET_BREADCRUMB, [
                { title: "Сервис", route: "sync-data-monitor" },
                {title: "Обмен данными", route: "sync-data-monitor"},
                {title: "Монитор"}
            ]);
        }
    }
</script>

<style scoped>

</style>